/* Niclas + ChatGPT | 2026-10-14 | PDP sibling image slider; native product links are preserved. */
(() => {
  'use strict';
  const selector = '#MainContent .avolt-product-siblings .image-swatches';
  const mobile = window.matchMedia('(max-width: 767px)');
  const initialized = new WeakMap();
  const script = document.querySelector('script[data-avolt-product-selectors]');
  const groupLabel = script?.dataset.colorLabel || 'Colours';

  function setup(rail) {
    let state = initialized.get(rail);
    if (!state) {
      const track = document.createElement('div');
      const thumb = document.createElement('span');
      track.className = 'avolt-swatch-progress';
      track.setAttribute('aria-hidden', 'true');
      thumb.className = 'avolt-swatch-progress__thumb';
      track.append(thumb);
      rail.after(track);
      let frame = 0;
      const update = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        const overflow = mobile.matches && max > 1;
        track.hidden = !overflow;
        if (!overflow) return;
        const width = Math.min(100, rail.clientWidth / rail.scrollWidth * 100);
        thumb.style.width = width + '%';
        thumb.style.marginLeft = (Math.max(0, rail.scrollLeft) / max * (100 - width)) + '%';
      };
      const schedule = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = 0; update(); });
      };
      rail.addEventListener('scroll', schedule, { passive: true });
      rail.addEventListener('keydown', event => {
        if (!mobile.matches || event.target !== rail) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const step = rail.querySelector('.image-swatches__item')?.getBoundingClientRect().width || 64;
        rail.scrollBy({ left: (step + 8) * (event.key === 'ArrowRight' ? 1 : -1), behavior: 'auto' });
      });
      const observer = new ResizeObserver(schedule);
      observer.observe(rail);
      state = { update };
      initialized.set(rail, state);
    }
    if (mobile.matches) {
      rail.tabIndex = 0;
      rail.setAttribute('role', 'group');
      rail.setAttribute('aria-label', groupLabel);
      const selected = rail.querySelector('.image-swatches__item.selected');
      if (selected) {
        const railBox = rail.getBoundingClientRect();
        const itemBox = selected.getBoundingClientRect();
        const position = rail.scrollLeft + itemBox.left - railBox.left - (rail.clientWidth - itemBox.width) / 2;
        rail.scrollTo({ left: Math.max(0, position), behavior: 'auto' });
      }
    } else {
      rail.removeAttribute('tabindex');
      rail.removeAttribute('role');
      rail.removeAttribute('aria-label');
    }
    state.update();
  }
  function initialize(root = document) { root.querySelectorAll(selector).forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  mobile.addEventListener('change', () => initialize());
  window.addEventListener('pageshow', () => initialize());
})();
